export default ({ i18n }) => ({
  key: 'created-by',
  name: i18n.getString(_TL_('Created by')),
  fieldName: 'CreatedBy/Name',
  minWidth: 70,
  maxWidth: 90,
  isResizable: true,
  sortable: true,
  data: 'number',
  onRender: item => (item.CreatedBy && item.CreatedBy.Name) || '-',
});
